module["exports"] = [
  "майдан"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/uk/address/street_suffix.js
 ** module id = 1131
 ** module chunks = 0
 **/